import { resetTokenCookie } from "../../../service/authorization"
import jwtDecode from "jwt-decode"
import React from "react"

function getPdiRetailLogoutUri(tunnelData) {
  if (!tunnelData?.pdiRetailUrl) {
    console.error("Missing pdiRetailUrl in tunnelData, cannot redirect after logout")
    return null
  }

  let logoutUri
  try {
    logoutUri = new URL(tunnelData.pdiRetailUrl)
  } catch (error) {
    console.error("Invalid pdiRetailUrl in tunnelData:", tunnelData.pdiRetailUrl, error)
    return null
  }

  if (!["http:", "https:"].includes(logoutUri.protocol)) {
    console.error("Unsafe protocol in pdiRetailUrl:", logoutUri.protocol)
    return null
  }

  if (tunnelData.tenant) {
    logoutUri.searchParams.set("tenant", String(tunnelData.tenant))
  }
  logoutUri.searchParams.set("pdiLogout", "true")
  return logoutUri.toString()
}

const LogoutButton = ({ tunnelData }) => {
  const token = sessionStorage.getItem("user_token") && jwtDecode(sessionStorage.getItem("user_token"))

  function logOut() {
    const pdiRetailLogoutUri = getPdiRetailLogoutUri(tunnelData)
    sessionStorage.clear()
    localStorage.clear()
    resetTokenCookie()
    if (pdiRetailLogoutUri) {
      window.location.href = pdiRetailLogoutUri
    }
  }

   if (!token) return null

  return (
    <div className="div-logout">
      <h1 className="username">{token?.name}</h1>
      <i className="fa fa-sign-out" aria-hidden="true" onClick={logOut} />
    </div>
  )
}

export default LogoutButton
